export default __webpack_public_path__ + "static/Deployment-909df41c52df7084652999c89cb0e374.webp";